import { Component, Input } from '@angular/core';
import { Location, NgStyle } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    imports: [NgStyle],
})
export class BackButtonComponent {
  @Input() public customColour: string = '';

  @Input() public isReportingPage: boolean = false;

  public allowedRoutes = [
    'my-profile',
    'wellbeing',
    'student-life',
    'register',
    'contact',
  ];

  public showBack = false;

  constructor(private location: Location, private router: Router) {
    this.router.events.subscribe((_) => {
      this.showBack = false;
      this.allowedRoutes.forEach((route) => {
        const currentUrl = this.router.url;

        if (currentUrl.toLowerCase().includes(route.toLowerCase())) {
          this.showBack = true;
        }
      });
    });
  }

  public goBack(): void {
    this.location.back();
  }
}
